// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * Tavern Theme - Common UI Components
 * Reusable styled components for the tavern theme
 */

/* ========== Button Components ========== */

/* Secondary Button (Outline) */
.tavern-btn-secondary {
  background: transparent;
  color: var(--color-fire-600);
  border: 2px solid var(--color-fire-600);
  padding: var(--space-2) var(--space-5);
  border-radius: var(--radius-md);
  font-family: var(--font-body);
  font-weight: var(--font-weight-semibold);
  font-size: var(--font-size-body);
  cursor: pointer;
  transition: all var(--transition-fast) var(--transition-timing);
}

.tavern-btn-secondary:hover:not(:disabled) {
  background: rgba(184, 71, 14, 0.1);
}

.tavern-btn-secondary:active:not(:disabled) {
  background: rgba(184, 71, 14, 0.2);
}

/* Danger Button */
.tavern-btn-danger {
  width: 100%;
  height: 52px;
  border-radius: var(--radius-md);
  border: 2px solid var(--color-wood-700);
  background: var(--color-danger-500);
  color: var(--color-parchment-100);
  font-family: var(--font-body);
  font-weight: var(--font-weight-semibold);
  font-size: var(--font-size-body);
  padding: var(--space-3) var(--space-5);
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: var(--shadow-button);
  cursor: pointer;
  transition: all var(--transition-fast) var(--transition-timing);
}

.tavern-btn-danger:hover:not(:disabled) {
  background: var(--color-danger-600);
  transform: translateY(-1px);
}

.tavern-btn-danger:active:not(:disabled) {
  transform: translateY(0);
}

/* Icon Button (small) */
.tavern-btn-icon {
  width: 32px;
  height: 32px;
  border-radius: var(--radius-full);
  background: transparent;
  border: none;
  color: var(--color-fire-600);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  cursor: pointer;
  transition: all var(--transition-fast) var(--transition-timing);
}

.tavern-btn-icon:hover:not(:disabled) {
  background: rgba(184, 71, 14, 0.1);
}

.tavern-btn-icon--danger {
  color: var(--color-danger-500);
}

.tavern-btn-icon--danger:hover:not(:disabled) {
  background: rgba(168, 52, 42, 0.1);
}

/* ========== Badge Components ========== */

.tavern-badge {
  display: inline-flex;
  align-items: center;
  gap: var(--space-1);
  height: 24px;
  padding: 0 var(--space-2);
  border-radius: var(--radius-xl);
  font-family: var(--font-body);
  font-size: var(--font-size-caption);
  font-weight: var(--font-weight-semibold);
  text-transform: uppercase;
  letter-spacing: 0.05em;
  white-space: nowrap;
}

/* Event Type Badges */
.tavern-badge--type {
  background: var(--color-wood-700);
  color: var(--color-parchment-100);
}

/* Open/Private Badges */
.tavern-badge--open {
  background: var(--color-success-500);
  color: white;
}

.tavern-badge--private {
  background: var(--color-info-500);
  color: white;
}

/* ========== Card Components ========== */

.tavern-card--event {
  background: var(--color-parchment-100);
  
  /* Текстура пергамента из прототипа */
  background-image: 
    radial-gradient(
      circle at 20% 30%,
      rgba(139, 69, 19, 0.12) 0%,
      transparent 50%
    ),
    radial-gradient(
      circle at 80% 70%,
      rgba(160, 82, 45, 0.08) 0%,
      transparent 50%
    ),
    radial-gradient(
      circle at 50% 50%,
      rgba(210, 180, 140, 0.15) 0%,
      transparent 80%
    ),
    repeating-linear-gradient(
      0deg,
      transparent,
      transparent 2px,
      rgba(139, 69, 19, 0.06) 2px,
      rgba(139, 69, 19, 0.06) 3px
    ),
    repeating-linear-gradient(
      90deg,
      transparent,
      transparent 100px,
      rgba(160, 82, 45, 0.03) 100px,
      rgba(160, 82, 45, 0.03) 101px
    );
  
  border-radius: var(--radius-xl);
  padding: var(--space-5);
  border: 3px solid var(--color-wood-700);
  box-shadow: var(--shadow-card);
  margin-bottom: var(--space-3);
  animation: fade-in-up 400ms ease-out backwards;
}

.tavern-card--event:nth-child(1) {
  animation-delay: 50ms;
}
.tavern-card--event:nth-child(2) {
  animation-delay: 100ms;
}
.tavern-card--event:nth-child(3) {
  animation-delay: 150ms;
}
.tavern-card--event:nth-child(4) {
  animation-delay: 200ms;
}
.tavern-card--event:nth-child(5) {
  animation-delay: 250ms;
}

.tavern-card-header {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: var(--space-2);
  margin-bottom: var(--space-3);
  padding-bottom: var(--space-3);
  border-bottom: 2px solid var(--color-wood-600);
}

.tavern-card-title {
  font-family: var(--font-heading);
  font-size: 18px;
  font-weight: var(--font-weight-bold);
  color: var(--color-fire-600);
  margin: 0;
  flex: 1 1 auto;
  min-width: 0;
}

.tavern-card-meta {
  display: flex;
  align-items: center;
  gap: var(--space-2);
  flex-wrap: wrap;
  font-size: var(--font-size-body-sm);
  color: var(--color-text-secondary);
}

.tavern-card-time {
  font-family: var(--font-body);
  font-size: 16px;
  font-weight: 700;
  color: var(--color-fire-600);
  background: rgba(209, 97, 28, 0.1);
  padding: 6px 12px;
  border-radius: var(--radius-md);
  border: 2px solid var(--color-fire-500);
  white-space: nowrap;
  font-variant-numeric: tabular-nums;
  display: inline-flex;
  align-items: center;
  gap: 4px;
}

.tavern-card-time::before {
  content: '🕐';
  font-size: 16px;
}

@media (max-width: 425px) {
  .tavern-card--event {
    padding: var(--space-3);
    border-width: 2px;
    border-radius: 14px;
    margin-bottom: var(--space-2);
  }

  .tavern-card-header {
    margin-bottom: var(--space-2);
    padding-bottom: var(--space-2);
  }

  .tavern-card-title {
    font-size: 16px;
    overflow-wrap: anywhere;
  }

  .tavern-card-meta {
    gap: var(--space-1);
  }

  .tavern-badge {
    max-width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .tavern-card-time {
    font-size: 13px;
    padding: 4px 8px;
    border-width: 1px;
  }

  .tavern-card-time::before {
    font-size: 13px;
  }

  .tavern-badge {
    height: 20px;
    padding: 0 8px;
    font-size: 10px;
  }
}

/* ========== Slot Components ========== */

.tavern-slot {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: var(--space-3);
  background: white;
  border: 2px solid var(--color-wood-600);
  border-radius: var(--radius-md);
  margin-bottom: var(--space-2);
  transition: all var(--transition-fast);
  min-height: 48px;
}

/* Confirmed Slot */
.tavern-slot--confirmed {
  border-color: var(--color-success-500);
  background: rgba(74, 124, 89, 0.05);
}

/* Pending Slot */
.tavern-slot--pending {
  border-color: var(--color-warning-500);
  background: rgba(212, 167, 74, 0.05);
}

/* Empty/Available Slot */
.tavern-slot--empty {
  border-style: dashed;
  border-color: var(--color-wood-600);
  cursor: pointer;
}

.tavern-slot--empty:hover {
  background: rgba(184, 71, 14, 0.05);
  border-color: var(--color-fire-600);
}

/* Closed Slot (private events) */
.tavern-slot--closed {
  border: 2px dashed var(--color-wood-700);
  background: rgba(62, 47, 34, 0.1);
  opacity: 0.6;
  cursor: not-allowed;
}

.tavern-slot-icon {
  font-size: 18px;
  flex-shrink: 0;
}

.tavern-slot-icon--confirmed {
  color: var(--color-success-500);
}

.tavern-slot-icon--pending {
  color: var(--color-warning-500);
}

.tavern-slot-name {
  flex: 1;
  font-family: var(--font-body);
  font-size: var(--font-size-body);
  font-weight: var(--font-weight-medium);
  color: var(--color-text-primary);
}

.tavern-slot-name--me {
  font-weight: var(--font-weight-bold);
}

.tavern-slot-name--empty {
  color: var(--color-text-tertiary);
  font-style: italic;
}

/* ========== Header Components ========== */

/* Day Header (sticky) */
.tavern-day-header {
  background: var(--color-wood-800);
  color: var(--color-parchment-100);
  font-family: var(--font-heading);
  font-size: 18px;
  font-weight: var(--font-weight-bold);
  letter-spacing: 0.05em;
  text-align: center;
  padding: var(--space-2);
  margin: var(--space-2) var(--space-2) var(--space-1);
  border: 2px solid var(--color-wood-700);
  border-radius: var(--radius-lg);
  box-shadow: var(--shadow-md);
  position: sticky;
  top: 0;
  z-index: var(--z-sticky);
}

.tavern-day-header::after {
  content: '';
  display: block;
  width: 60%;
  height: 2px;
  background: linear-gradient(
    to right,
    transparent,
    var(--color-fire-600) 50%,
    transparent
  );
  margin: var(--space-2) auto 0;
}

.tavern-day-header--no-uppercase {
  text-transform: none;
}

/* Today's Header */
.tavern-day-header--today {
  background: linear-gradient(
    135deg,
    var(--color-wood-800),
    var(--color-fire-600) 150%
  );
  border-color: var(--color-fire-600);
  box-shadow: var(--shadow-md), 0 0 16px rgba(184, 71, 14, 0.4);
}

/* Table Subheader */
.tavern-table-header {
  background: var(--color-wood-700);
  color: var(--color-parchment-200);
  font-family: var(--font-body);
  font-size: 14px;
  font-weight: var(--font-weight-semibold);
  padding: var(--space-2) var(--space-4);
  border-left: 4px solid var(--color-fire-600);
  margin: var(--space-2) 0;
  border-radius: var(--radius-sm);
}

/* ========== Modal/Overlay Components ========== */

.tavern-modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(26, 20, 16, 0.75);
  backdrop-filter: blur(4px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: var(--z-modal);
  animation: fade-in var(--transition-normal) var(--transition-timing);
}

.tavern-modal {
  background: var(--color-parchment-100);
  border: 3px solid var(--color-wood-700);
  border-radius: var(--radius-xl);
  box-shadow: var(--shadow-modal);
  padding: var(--space-5);
  max-width: 90vw;
  max-height: 80vh;
  overflow-y: auto;
  animation: fade-in-scale var(--transition-slow) var(--transition-timing);
}

.tavern-modal-title {
  font-family: var(--font-heading);
  font-size: var(--font-size-h3);
  font-weight: var(--font-weight-bold);
  color: var(--color-fire-600);
  text-align: center;
  margin-bottom: var(--space-4);
}

.tavern-modal-content {
  font-family: var(--font-body);
  font-size: var(--font-size-body);
  line-height: var(--line-height-body-lg);
  color: var(--color-text-primary);
  margin-bottom: var(--space-5);
}

.tavern-modal-actions {
  display: flex;
  gap: var(--space-3);
  justify-content: center;
}

/* ========== Loading Components ========== */

.tavern-loading {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: var(--space-7);
  color: var(--color-text-tertiary);
}

.tavern-spinner {
  width: 40px;
  height: 40px;
  border: 3px solid var(--color-wood-700);
  border-top-color: var(--color-fire-600);
  border-radius: var(--radius-full);
  animation: rotation 1s linear infinite;
  margin-bottom: var(--space-4);
}

/* ========== Empty State ========== */

.tavern-empty-state {
  text-align: center;
  padding: var(--space-7) var(--space-5);
  color: var(--color-text-tertiary);
}

.tavern-empty-state-icon {
  font-size: 64px;
  line-height: 1.2;
  opacity: 0.4;
  margin-bottom: var(--space-4);
}

.tavern-empty-state-title {
  font-family: var(--font-heading);
  font-size: var(--font-size-h3);
  font-weight: var(--font-weight-semibold);
  /* Пустые состояния лежат на тёмном фоне страницы, тёмный текст там не читается */
  color: var(--color-text-secondary-light);
  margin-bottom: var(--space-2);
}

.tavern-empty-state-description {
  font-family: var(--font-body);
  font-size: var(--font-size-body);
  color: var(--color-text-secondary-light);
  opacity: 0.8;
}

/* ========== Link Button ========== */
/* Button styled as a link for accessibility (replaces <a href="#">) */
.link-button {
  display: inline;
  padding: 0;
  margin: 0;
  background: none;
  border: none;
  color: inherit;
  font: inherit;
  text-decoration: underline;
  cursor: pointer;
  text-align: left;
}

.link-button:hover {
  text-decoration: none;
}

.link-button:focus {
  outline: 2px solid var(--color-fire-600);
  outline-offset: 2px;
  border-radius: 2px;
}

/* Expandable text: clamped multi-line text with a toggle */
.ttbExpandableTextBody {
  white-space: pre-wrap;
  overflow-wrap: anywhere;
  font-size: 14px;
  line-height: 1.5;
  color: var(--color-text-secondary);
}

.ttbExpandableTextBody[data-markdown='true'] {
  white-space: normal;
}

.ttbExpandableTextBody[data-markdown='true'] > :first-child {
  margin-top: 0;
}

.ttbExpandableTextBody[data-markdown='true'] > :last-child {
  margin-bottom: 0;
}

.ttbExpandableTextBody[data-markdown='true'] p {
  margin: 0 0 var(--space-1);
}

.ttbExpandableTextBody[data-markdown='true'] ul,
.ttbExpandableTextBody[data-markdown='true'] ol {
  margin: 0 0 var(--space-1);
  padding-left: 1.25em;
}

.ttbExpandableTextBody[data-markdown='true'] blockquote {
  margin: 0 0 var(--space-1);
  padding-left: var(--space-2);
  border-left: 2px solid var(--color-fire-600);
}

.ttbExpandableTextBody[data-markdown='true'] code {
  font-family: monospace;
  font-size: 0.9em;
}

.ttbMdLevel--want {
  color: var(--color-success-600);
}

.ttbMdLevel--acceptable {
  color: var(--color-warning-700);
}

.ttbMdLevel--exclude {
  color: var(--color-danger-500);
}

.ttbExpandableTextBody[data-markdown='true'] a {
  color: var(--color-fire-600);
  text-decoration: underline;
}

.ttbExpandableTextBody[data-clamped='true'] {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}

.ttbExpandableTextToggle {
  margin-top: var(--space-1);
  padding: 0;
  background: none;
  border: none;
  font-family: var(--font-body);
  font-size: 13px;
  font-weight: 600;
  color: var(--color-fire-600);
  cursor: pointer;
}

/* ========== Switch ========== */
.ttbSwitch {
  position: relative; /* anchors the visually hidden input so it cannot stretch the page */
  display: inline-flex;
  flex-shrink: 0;
  align-items: center;
  gap: var(--space-2);
  min-height: 44px;
  cursor: pointer;
}

.ttbSwitch input {
  position: absolute;
  width: 1px;
  height: 1px;
  opacity: 0;
}

.ttbSwitchTrack {
  position: relative;
  width: 48px;
  height: 28px;
  border-radius: 14px;
  background: var(--color-wood-500);
  transition: background var(--transition-fast);
}

.ttbSwitchThumb {
  position: absolute;
  top: 3px;
  left: 3px;
  width: 22px;
  height: 22px;
  border-radius: 50%;
  background: var(--color-parchment-100);
  box-shadow: 0 1px 3px rgba(26, 20, 16, 0.35);
  transition: transform var(--transition-fast);
}

.ttbSwitch input:checked + .ttbSwitchTrack {
  background: var(--color-fire-600);
}

.ttbSwitch input:checked + .ttbSwitchTrack .ttbSwitchThumb {
  transform: translateX(20px);
}

/* Partly on: thumb in the middle, track between the off and on colors */
.ttbSwitch[data-mixed] input + .ttbSwitchTrack {
  background: var(--color-fire-400);
}

.ttbSwitch[data-mixed] input + .ttbSwitchTrack .ttbSwitchThumb {
  transform: translateX(10px);
}

.ttbSwitch input:focus-visible + .ttbSwitchTrack {
  outline: 3px solid var(--tg-theme-link-color, #2481cc);
  outline-offset: 2px;
}

.ttbSwitch input:disabled + .ttbSwitchTrack {
  opacity: 0.6;
}

.ttbSwitchLabel {
  max-width: 72px;
  color: var(--color-text-primary);
  font-size: 12px;
  font-weight: 600;
}
`, "",{"version":3,"sources":["webpack://./src/ui/styles/tavern-components.css"],"names":[],"mappings":"AAAA;;;EAGE;;AAEF,4CAA4C;;AAE5C,+BAA+B;AAC/B;EACE,uBAAuB;EACvB,4BAA4B;EAC5B,uCAAuC;EACvC,sCAAsC;EACtC,+BAA+B;EAC/B,6BAA6B;EAC7B,wCAAwC;EACxC,gCAAgC;EAChC,eAAe;EACf,+DAA+D;AACjE;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,kCAAkC;AACpC;;AAEA,kBAAkB;AAClB;EACE,WAAW;EACX,YAAY;EACZ,+BAA+B;EAC/B,uCAAuC;EACvC,mCAAmC;EACnC,iCAAiC;EACjC,6BAA6B;EAC7B,wCAAwC;EACxC,gCAAgC;EAChC,sCAAsC;EACtC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gCAAgC;EAChC,eAAe;EACf,+DAA+D;AACjE;;AAEA;EACE,mCAAmC;EACnC,2BAA2B;AAC7B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA,wBAAwB;AACxB;EACE,WAAW;EACX,YAAY;EACZ,iCAAiC;EACjC,uBAAuB;EACvB,YAAY;EACZ,4BAA4B;EAC5B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,eAAe;EACf,+DAA+D;AACjE;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,kCAAkC;AACpC;;AAEA,2CAA2C;;AAE3C;EACE,oBAAoB;EACpB,mBAAmB;EACnB,mBAAmB;EACnB,YAAY;EACZ,yBAAyB;EACzB,+BAA+B;EAC/B,6BAA6B;EAC7B,mCAAmC;EACnC,wCAAwC;EACxC,yBAAyB;EACzB,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA,sBAAsB;AACtB;EACE,iCAAiC;EACjC,iCAAiC;AACnC;;AAEA,wBAAwB;AACxB;EACE,oCAAoC;EACpC,YAAY;AACd;;AAEA;EACE,iCAAiC;EACjC,YAAY;AACd;;AAEA,0CAA0C;;AAE1C;EACE,sCAAsC;;EAEtC,qCAAqC;EACrC;;;;;;;;;;;;;;;;;;;;;;;;;;;;;KA6BG;;EAEH,+BAA+B;EAC/B,uBAAuB;EACvB,uCAAuC;EACvC,8BAA8B;EAC9B,6BAA6B;EAC7B,8CAA8C;AAChD;;AAEA;EACE,qBAAqB;AACvB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,mBAAmB;EACnB,6BAA6B;EAC7B,8BAA8B;EAC9B,8CAA8C;AAChD;;AAEA;EACE,gCAAgC;EAChC,eAAe;EACf,oCAAoC;EACpC,4BAA4B;EAC5B,SAAS;EACT,cAAc;EACd,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA;EACE,6BAA6B;EAC7B,eAAe;EACf,gBAAgB;EAChB,4BAA4B;EAC5B,kCAAkC;EAClC,iBAAiB;EACjB,+BAA+B;EAC/B,uCAAuC;EACvC,mBAAmB;EACnB,kCAAkC;EAClC,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,eAAe;AACjB;;AAEA;EACE;IACE,uBAAuB;IACvB,iBAAiB;IACjB,mBAAmB;IACnB,6BAA6B;EAC/B;;EAEA;IACE,6BAA6B;IAC7B,8BAA8B;EAChC;;EAEA;IACE,eAAe;IACf,uBAAuB;EACzB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,uBAAuB;EACzB;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,YAAY;IACZ,cAAc;IACd,eAAe;EACjB;AACF;;AAEA,0CAA0C;;AAE1C;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,uBAAuB;EACvB,iBAAiB;EACjB,uCAAuC;EACvC,+BAA+B;EAC/B,6BAA6B;EAC7B,sCAAsC;EACtC,gBAAgB;AAClB;;AAEA,mBAAmB;AACnB;EACE,sCAAsC;EACtC,mCAAmC;AACrC;;AAEA,iBAAiB;AACjB;EACE,sCAAsC;EACtC,oCAAoC;AACtC;;AAEA,yBAAyB;AACzB;EACE,oBAAoB;EACpB,mCAAmC;EACnC,eAAe;AACjB;;AAEA;EACE,mCAAmC;EACnC,mCAAmC;AACrC;;AAEA,iCAAiC;AACjC;EACE,wCAAwC;EACxC,iCAAiC;EACjC,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,OAAO;EACP,6BAA6B;EAC7B,gCAAgC;EAChC,sCAAsC;EACtC,gCAAgC;AAClC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,iCAAiC;EACjC,kBAAkB;AACpB;;AAEA,4CAA4C;;AAE5C,wBAAwB;AACxB;EACE,iCAAiC;EACjC,iCAAiC;EACjC,gCAAgC;EAChC,eAAe;EACf,oCAAoC;EACpC,sBAAsB;EACtB,kBAAkB;EAClB,uBAAuB;EACvB,oDAAoD;EACpD,uCAAuC;EACvC,+BAA+B;EAC/B,4BAA4B;EAC5B,gBAAgB;EAChB,MAAM;EACN,wBAAwB;AAC1B;;AAEA;EACE,WAAW;EACX,cAAc;EACd,UAAU;EACV,WAAW;EACX;;;;;GAKC;EACD,6BAA6B;AAC/B;;AAEA;EACE,oBAAoB;AACtB;;AAEA,mBAAmB;AACnB;EACE;;;;GAIC;EACD,mCAAmC;EACnC,6DAA6D;AAC/D;;AAEA,oBAAoB;AACpB;EACE,iCAAiC;EACjC,iCAAiC;EACjC,6BAA6B;EAC7B,eAAe;EACf,wCAAwC;EACxC,sCAAsC;EACtC,4CAA4C;EAC5C,wBAAwB;EACxB,+BAA+B;AACjC;;AAEA,mDAAmD;;AAEnD;EACE,eAAe;EACf,QAAQ;EACR,kCAAkC;EAClC,0BAA0B;EAC1B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,uBAAuB;EACvB,oEAAoE;AACtE;;AAEA;EACE,sCAAsC;EACtC,uCAAuC;EACvC,+BAA+B;EAC/B,+BAA+B;EAC/B,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,wEAAwE;AAC1E;;AAEA;EACE,gCAAgC;EAChC,8BAA8B;EAC9B,oCAAoC;EACpC,4BAA4B;EAC5B,kBAAkB;EAClB,6BAA6B;AAC/B;;AAEA;EACE,6BAA6B;EAC7B,gCAAgC;EAChC,uCAAuC;EACvC,gCAAgC;EAChC,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA,6CAA6C;;AAE7C;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,uBAAuB;EACvB,iCAAiC;AACnC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,uCAAuC;EACvC,uCAAuC;EACvC,iCAAiC;EACjC,sCAAsC;EACtC,6BAA6B;AAC/B;;AAEA,sCAAsC;;AAEtC;EACE,kBAAkB;EAClB,sCAAsC;EACtC,iCAAiC;AACnC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,6BAA6B;AAC/B;;AAEA;EACE,gCAAgC;EAChC,8BAA8B;EAC9B,wCAAwC;EACxC,iFAAiF;EACjF,wCAAwC;EACxC,6BAA6B;AAC/B;;AAEA;EACE,6BAA6B;EAC7B,gCAAgC;EAChC,wCAAwC;EACxC,YAAY;AACd;;AAEA,sCAAsC;AACtC,sEAAsE;AACtE;EACE,eAAe;EACf,UAAU;EACV,SAAS;EACT,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,aAAa;EACb,0BAA0B;EAC1B,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,wCAAwC;EACxC,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA,2DAA2D;AAC3D;EACE,qBAAqB;EACrB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,kCAAkC;AACpC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;;EAEE,0BAA0B;EAC1B,oBAAoB;AACtB;;AAEA;EACE,0BAA0B;EAC1B,4BAA4B;EAC5B,4CAA4C;AAC9C;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,4BAA4B;EAC5B,0BAA0B;AAC5B;;AAEA;EACE,oBAAoB;EACpB,4BAA4B;EAC5B,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,0BAA0B;EAC1B,UAAU;EACV,gBAAgB;EAChB,YAAY;EACZ,6BAA6B;EAC7B,eAAe;EACf,gBAAgB;EAChB,4BAA4B;EAC5B,eAAe;AACjB;;AAEA,iCAAiC;AACjC;EACE,kBAAkB,EAAE,oEAAoE;EACxF,oBAAoB;EACpB,cAAc;EACd,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,iCAAiC;EACjC,6CAA6C;AAC/C;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,sCAAsC;EACtC,4CAA4C;EAC5C,4CAA4C;AAC9C;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA,wEAAwE;AACxE;EACE,iCAAiC;AACnC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,sDAAsD;EACtD,mBAAmB;AACrB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gCAAgC;EAChC,eAAe;EACf,gBAAgB;AAClB","sourcesContent":["/**\n * Tavern Theme - Common UI Components\n * Reusable styled components for the tavern theme\n */\n\n/* ========== Button Components ========== */\n\n/* Secondary Button (Outline) */\n.tavern-btn-secondary {\n  background: transparent;\n  color: var(--color-fire-600);\n  border: 2px solid var(--color-fire-600);\n  padding: var(--space-2) var(--space-5);\n  border-radius: var(--radius-md);\n  font-family: var(--font-body);\n  font-weight: var(--font-weight-semibold);\n  font-size: var(--font-size-body);\n  cursor: pointer;\n  transition: all var(--transition-fast) var(--transition-timing);\n}\n\n.tavern-btn-secondary:hover:not(:disabled) {\n  background: rgba(184, 71, 14, 0.1);\n}\n\n.tavern-btn-secondary:active:not(:disabled) {\n  background: rgba(184, 71, 14, 0.2);\n}\n\n/* Danger Button */\n.tavern-btn-danger {\n  width: 100%;\n  height: 52px;\n  border-radius: var(--radius-md);\n  border: 2px solid var(--color-wood-700);\n  background: var(--color-danger-500);\n  color: var(--color-parchment-100);\n  font-family: var(--font-body);\n  font-weight: var(--font-weight-semibold);\n  font-size: var(--font-size-body);\n  padding: var(--space-3) var(--space-5);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  box-shadow: var(--shadow-button);\n  cursor: pointer;\n  transition: all var(--transition-fast) var(--transition-timing);\n}\n\n.tavern-btn-danger:hover:not(:disabled) {\n  background: var(--color-danger-600);\n  transform: translateY(-1px);\n}\n\n.tavern-btn-danger:active:not(:disabled) {\n  transform: translateY(0);\n}\n\n/* Icon Button (small) */\n.tavern-btn-icon {\n  width: 32px;\n  height: 32px;\n  border-radius: var(--radius-full);\n  background: transparent;\n  border: none;\n  color: var(--color-fire-600);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 18px;\n  cursor: pointer;\n  transition: all var(--transition-fast) var(--transition-timing);\n}\n\n.tavern-btn-icon:hover:not(:disabled) {\n  background: rgba(184, 71, 14, 0.1);\n}\n\n.tavern-btn-icon--danger {\n  color: var(--color-danger-500);\n}\n\n.tavern-btn-icon--danger:hover:not(:disabled) {\n  background: rgba(168, 52, 42, 0.1);\n}\n\n/* ========== Badge Components ========== */\n\n.tavern-badge {\n  display: inline-flex;\n  align-items: center;\n  gap: var(--space-1);\n  height: 24px;\n  padding: 0 var(--space-2);\n  border-radius: var(--radius-xl);\n  font-family: var(--font-body);\n  font-size: var(--font-size-caption);\n  font-weight: var(--font-weight-semibold);\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n  white-space: nowrap;\n}\n\n/* Event Type Badges */\n.tavern-badge--type {\n  background: var(--color-wood-700);\n  color: var(--color-parchment-100);\n}\n\n/* Open/Private Badges */\n.tavern-badge--open {\n  background: var(--color-success-500);\n  color: white;\n}\n\n.tavern-badge--private {\n  background: var(--color-info-500);\n  color: white;\n}\n\n/* ========== Card Components ========== */\n\n.tavern-card--event {\n  background: var(--color-parchment-100);\n  \n  /* Текстура пергамента из прототипа */\n  background-image: \n    radial-gradient(\n      circle at 20% 30%,\n      rgba(139, 69, 19, 0.12) 0%,\n      transparent 50%\n    ),\n    radial-gradient(\n      circle at 80% 70%,\n      rgba(160, 82, 45, 0.08) 0%,\n      transparent 50%\n    ),\n    radial-gradient(\n      circle at 50% 50%,\n      rgba(210, 180, 140, 0.15) 0%,\n      transparent 80%\n    ),\n    repeating-linear-gradient(\n      0deg,\n      transparent,\n      transparent 2px,\n      rgba(139, 69, 19, 0.06) 2px,\n      rgba(139, 69, 19, 0.06) 3px\n    ),\n    repeating-linear-gradient(\n      90deg,\n      transparent,\n      transparent 100px,\n      rgba(160, 82, 45, 0.03) 100px,\n      rgba(160, 82, 45, 0.03) 101px\n    );\n  \n  border-radius: var(--radius-xl);\n  padding: var(--space-5);\n  border: 3px solid var(--color-wood-700);\n  box-shadow: var(--shadow-card);\n  margin-bottom: var(--space-3);\n  animation: fade-in-up 400ms ease-out backwards;\n}\n\n.tavern-card--event:nth-child(1) {\n  animation-delay: 50ms;\n}\n.tavern-card--event:nth-child(2) {\n  animation-delay: 100ms;\n}\n.tavern-card--event:nth-child(3) {\n  animation-delay: 150ms;\n}\n.tavern-card--event:nth-child(4) {\n  animation-delay: 200ms;\n}\n.tavern-card--event:nth-child(5) {\n  animation-delay: 250ms;\n}\n\n.tavern-card-header {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: var(--space-2);\n  margin-bottom: var(--space-3);\n  padding-bottom: var(--space-3);\n  border-bottom: 2px solid var(--color-wood-600);\n}\n\n.tavern-card-title {\n  font-family: var(--font-heading);\n  font-size: 18px;\n  font-weight: var(--font-weight-bold);\n  color: var(--color-fire-600);\n  margin: 0;\n  flex: 1 1 auto;\n  min-width: 0;\n}\n\n.tavern-card-meta {\n  display: flex;\n  align-items: center;\n  gap: var(--space-2);\n  flex-wrap: wrap;\n  font-size: var(--font-size-body-sm);\n  color: var(--color-text-secondary);\n}\n\n.tavern-card-time {\n  font-family: var(--font-body);\n  font-size: 16px;\n  font-weight: 700;\n  color: var(--color-fire-600);\n  background: rgba(209, 97, 28, 0.1);\n  padding: 6px 12px;\n  border-radius: var(--radius-md);\n  border: 2px solid var(--color-fire-500);\n  white-space: nowrap;\n  font-variant-numeric: tabular-nums;\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n}\n\n.tavern-card-time::before {\n  content: '🕐';\n  font-size: 16px;\n}\n\n@media (max-width: 425px) {\n  .tavern-card--event {\n    padding: var(--space-3);\n    border-width: 2px;\n    border-radius: 14px;\n    margin-bottom: var(--space-2);\n  }\n\n  .tavern-card-header {\n    margin-bottom: var(--space-2);\n    padding-bottom: var(--space-2);\n  }\n\n  .tavern-card-title {\n    font-size: 16px;\n    overflow-wrap: anywhere;\n  }\n\n  .tavern-card-meta {\n    gap: var(--space-1);\n  }\n\n  .tavern-badge {\n    max-width: 100%;\n    overflow: hidden;\n    text-overflow: ellipsis;\n  }\n\n  .tavern-card-time {\n    font-size: 13px;\n    padding: 4px 8px;\n    border-width: 1px;\n  }\n\n  .tavern-card-time::before {\n    font-size: 13px;\n  }\n\n  .tavern-badge {\n    height: 20px;\n    padding: 0 8px;\n    font-size: 10px;\n  }\n}\n\n/* ========== Slot Components ========== */\n\n.tavern-slot {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: var(--space-3);\n  background: white;\n  border: 2px solid var(--color-wood-600);\n  border-radius: var(--radius-md);\n  margin-bottom: var(--space-2);\n  transition: all var(--transition-fast);\n  min-height: 48px;\n}\n\n/* Confirmed Slot */\n.tavern-slot--confirmed {\n  border-color: var(--color-success-500);\n  background: rgba(74, 124, 89, 0.05);\n}\n\n/* Pending Slot */\n.tavern-slot--pending {\n  border-color: var(--color-warning-500);\n  background: rgba(212, 167, 74, 0.05);\n}\n\n/* Empty/Available Slot */\n.tavern-slot--empty {\n  border-style: dashed;\n  border-color: var(--color-wood-600);\n  cursor: pointer;\n}\n\n.tavern-slot--empty:hover {\n  background: rgba(184, 71, 14, 0.05);\n  border-color: var(--color-fire-600);\n}\n\n/* Closed Slot (private events) */\n.tavern-slot--closed {\n  border: 2px dashed var(--color-wood-700);\n  background: rgba(62, 47, 34, 0.1);\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n.tavern-slot-icon {\n  font-size: 18px;\n  flex-shrink: 0;\n}\n\n.tavern-slot-icon--confirmed {\n  color: var(--color-success-500);\n}\n\n.tavern-slot-icon--pending {\n  color: var(--color-warning-500);\n}\n\n.tavern-slot-name {\n  flex: 1;\n  font-family: var(--font-body);\n  font-size: var(--font-size-body);\n  font-weight: var(--font-weight-medium);\n  color: var(--color-text-primary);\n}\n\n.tavern-slot-name--me {\n  font-weight: var(--font-weight-bold);\n}\n\n.tavern-slot-name--empty {\n  color: var(--color-text-tertiary);\n  font-style: italic;\n}\n\n/* ========== Header Components ========== */\n\n/* Day Header (sticky) */\n.tavern-day-header {\n  background: var(--color-wood-800);\n  color: var(--color-parchment-100);\n  font-family: var(--font-heading);\n  font-size: 18px;\n  font-weight: var(--font-weight-bold);\n  letter-spacing: 0.05em;\n  text-align: center;\n  padding: var(--space-2);\n  margin: var(--space-2) var(--space-2) var(--space-1);\n  border: 2px solid var(--color-wood-700);\n  border-radius: var(--radius-lg);\n  box-shadow: var(--shadow-md);\n  position: sticky;\n  top: 0;\n  z-index: var(--z-sticky);\n}\n\n.tavern-day-header::after {\n  content: '';\n  display: block;\n  width: 60%;\n  height: 2px;\n  background: linear-gradient(\n    to right,\n    transparent,\n    var(--color-fire-600) 50%,\n    transparent\n  );\n  margin: var(--space-2) auto 0;\n}\n\n.tavern-day-header--no-uppercase {\n  text-transform: none;\n}\n\n/* Today's Header */\n.tavern-day-header--today {\n  background: linear-gradient(\n    135deg,\n    var(--color-wood-800),\n    var(--color-fire-600) 150%\n  );\n  border-color: var(--color-fire-600);\n  box-shadow: var(--shadow-md), 0 0 16px rgba(184, 71, 14, 0.4);\n}\n\n/* Table Subheader */\n.tavern-table-header {\n  background: var(--color-wood-700);\n  color: var(--color-parchment-200);\n  font-family: var(--font-body);\n  font-size: 14px;\n  font-weight: var(--font-weight-semibold);\n  padding: var(--space-2) var(--space-4);\n  border-left: 4px solid var(--color-fire-600);\n  margin: var(--space-2) 0;\n  border-radius: var(--radius-sm);\n}\n\n/* ========== Modal/Overlay Components ========== */\n\n.tavern-modal-overlay {\n  position: fixed;\n  inset: 0;\n  background: rgba(26, 20, 16, 0.75);\n  backdrop-filter: blur(4px);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: var(--z-modal);\n  animation: fade-in var(--transition-normal) var(--transition-timing);\n}\n\n.tavern-modal {\n  background: var(--color-parchment-100);\n  border: 3px solid var(--color-wood-700);\n  border-radius: var(--radius-xl);\n  box-shadow: var(--shadow-modal);\n  padding: var(--space-5);\n  max-width: 90vw;\n  max-height: 80vh;\n  overflow-y: auto;\n  animation: fade-in-scale var(--transition-slow) var(--transition-timing);\n}\n\n.tavern-modal-title {\n  font-family: var(--font-heading);\n  font-size: var(--font-size-h3);\n  font-weight: var(--font-weight-bold);\n  color: var(--color-fire-600);\n  text-align: center;\n  margin-bottom: var(--space-4);\n}\n\n.tavern-modal-content {\n  font-family: var(--font-body);\n  font-size: var(--font-size-body);\n  line-height: var(--line-height-body-lg);\n  color: var(--color-text-primary);\n  margin-bottom: var(--space-5);\n}\n\n.tavern-modal-actions {\n  display: flex;\n  gap: var(--space-3);\n  justify-content: center;\n}\n\n/* ========== Loading Components ========== */\n\n.tavern-loading {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: var(--space-7);\n  color: var(--color-text-tertiary);\n}\n\n.tavern-spinner {\n  width: 40px;\n  height: 40px;\n  border: 3px solid var(--color-wood-700);\n  border-top-color: var(--color-fire-600);\n  border-radius: var(--radius-full);\n  animation: rotation 1s linear infinite;\n  margin-bottom: var(--space-4);\n}\n\n/* ========== Empty State ========== */\n\n.tavern-empty-state {\n  text-align: center;\n  padding: var(--space-7) var(--space-5);\n  color: var(--color-text-tertiary);\n}\n\n.tavern-empty-state-icon {\n  font-size: 64px;\n  line-height: 1.2;\n  opacity: 0.4;\n  margin-bottom: var(--space-4);\n}\n\n.tavern-empty-state-title {\n  font-family: var(--font-heading);\n  font-size: var(--font-size-h3);\n  font-weight: var(--font-weight-semibold);\n  /* Пустые состояния лежат на тёмном фоне страницы, тёмный текст там не читается */\n  color: var(--color-text-secondary-light);\n  margin-bottom: var(--space-2);\n}\n\n.tavern-empty-state-description {\n  font-family: var(--font-body);\n  font-size: var(--font-size-body);\n  color: var(--color-text-secondary-light);\n  opacity: 0.8;\n}\n\n/* ========== Link Button ========== */\n/* Button styled as a link for accessibility (replaces <a href=\"#\">) */\n.link-button {\n  display: inline;\n  padding: 0;\n  margin: 0;\n  background: none;\n  border: none;\n  color: inherit;\n  font: inherit;\n  text-decoration: underline;\n  cursor: pointer;\n  text-align: left;\n}\n\n.link-button:hover {\n  text-decoration: none;\n}\n\n.link-button:focus {\n  outline: 2px solid var(--color-fire-600);\n  outline-offset: 2px;\n  border-radius: 2px;\n}\n\n/* Expandable text: clamped multi-line text with a toggle */\n.ttbExpandableTextBody {\n  white-space: pre-wrap;\n  overflow-wrap: anywhere;\n  font-size: 14px;\n  line-height: 1.5;\n  color: var(--color-text-secondary);\n}\n\n.ttbExpandableTextBody[data-markdown='true'] {\n  white-space: normal;\n}\n\n.ttbExpandableTextBody[data-markdown='true'] > :first-child {\n  margin-top: 0;\n}\n\n.ttbExpandableTextBody[data-markdown='true'] > :last-child {\n  margin-bottom: 0;\n}\n\n.ttbExpandableTextBody[data-markdown='true'] p {\n  margin: 0 0 var(--space-1);\n}\n\n.ttbExpandableTextBody[data-markdown='true'] ul,\n.ttbExpandableTextBody[data-markdown='true'] ol {\n  margin: 0 0 var(--space-1);\n  padding-left: 1.25em;\n}\n\n.ttbExpandableTextBody[data-markdown='true'] blockquote {\n  margin: 0 0 var(--space-1);\n  padding-left: var(--space-2);\n  border-left: 2px solid var(--color-fire-600);\n}\n\n.ttbExpandableTextBody[data-markdown='true'] code {\n  font-family: monospace;\n  font-size: 0.9em;\n}\n\n.ttbMdLevel--want {\n  color: var(--color-success-600);\n}\n\n.ttbMdLevel--acceptable {\n  color: var(--color-warning-700);\n}\n\n.ttbMdLevel--exclude {\n  color: var(--color-danger-500);\n}\n\n.ttbExpandableTextBody[data-markdown='true'] a {\n  color: var(--color-fire-600);\n  text-decoration: underline;\n}\n\n.ttbExpandableTextBody[data-clamped='true'] {\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.ttbExpandableTextToggle {\n  margin-top: var(--space-1);\n  padding: 0;\n  background: none;\n  border: none;\n  font-family: var(--font-body);\n  font-size: 13px;\n  font-weight: 600;\n  color: var(--color-fire-600);\n  cursor: pointer;\n}\n\n/* ========== Switch ========== */\n.ttbSwitch {\n  position: relative; /* anchors the visually hidden input so it cannot stretch the page */\n  display: inline-flex;\n  flex-shrink: 0;\n  align-items: center;\n  gap: var(--space-2);\n  min-height: 44px;\n  cursor: pointer;\n}\n\n.ttbSwitch input {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  opacity: 0;\n}\n\n.ttbSwitchTrack {\n  position: relative;\n  width: 48px;\n  height: 28px;\n  border-radius: 14px;\n  background: var(--color-wood-500);\n  transition: background var(--transition-fast);\n}\n\n.ttbSwitchThumb {\n  position: absolute;\n  top: 3px;\n  left: 3px;\n  width: 22px;\n  height: 22px;\n  border-radius: 50%;\n  background: var(--color-parchment-100);\n  box-shadow: 0 1px 3px rgba(26, 20, 16, 0.35);\n  transition: transform var(--transition-fast);\n}\n\n.ttbSwitch input:checked + .ttbSwitchTrack {\n  background: var(--color-fire-600);\n}\n\n.ttbSwitch input:checked + .ttbSwitchTrack .ttbSwitchThumb {\n  transform: translateX(20px);\n}\n\n/* Partly on: thumb in the middle, track between the off and on colors */\n.ttbSwitch[data-mixed] input + .ttbSwitchTrack {\n  background: var(--color-fire-400);\n}\n\n.ttbSwitch[data-mixed] input + .ttbSwitchTrack .ttbSwitchThumb {\n  transform: translateX(10px);\n}\n\n.ttbSwitch input:focus-visible + .ttbSwitchTrack {\n  outline: 3px solid var(--tg-theme-link-color, #2481cc);\n  outline-offset: 2px;\n}\n\n.ttbSwitch input:disabled + .ttbSwitchTrack {\n  opacity: 0.6;\n}\n\n.ttbSwitchLabel {\n  max-width: 72px;\n  color: var(--color-text-primary);\n  font-size: 12px;\n  font-weight: 600;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
